import { SHARE_OPTIONS } from '../constants'
import addUtmParams from './addUtmParams'

export type ShareableLinkDataDeprecated = {
  course: { slug: string }
  chapter: { slug: string }
  source: string
}

const getShareableLinksDeprecated = (
  shareData: ShareableLinkDataDeprecated,
  isLessonShare = false,
) => {
  const {
    course: { slug: courseSlug },
    chapter: { slug: chapterSlug } = {},
    source,
  } = shareData

  const location = global.location?.origin
  let link = `${location}/classes/${courseSlug}`

  if (isLessonShare) {
    link += `/chapters/${chapterSlug}`
  }

  return {
    facebook: addUtmParams({ link, channel: SHARE_OPTIONS.FACEBOOK, source }),
    messenger: addUtmParams({ link, channel: SHARE_OPTIONS.MESSENGER, source }),
    linkedin: addUtmParams({ link, channel: SHARE_OPTIONS.LINKEDIN, source }),
    twitter: addUtmParams({ link, channel: SHARE_OPTIONS.TWITTER, source }),
    email: addUtmParams({ link, channel: SHARE_OPTIONS.EMAIL, source }),
    copy: addUtmParams({ link, channel: SHARE_OPTIONS.COPY, source }),
    message: addUtmParams({ link, channel: SHARE_OPTIONS.MESSAGE, source }),
    more: addUtmParams({ link, channel: SHARE_OPTIONS.MORE, source }),
  }
}

export default getShareableLinksDeprecated
